module.exports = __webpack_public_path__ + "img/sslogo.83f970f6.png";